import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  BooleanField,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const NotificationList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });

  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "notification_id",
        title: "Notification Id",
        type: "number",
        headerAlign: "center",
        width: 100,
        align: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "user_id",
        title: "User Id",
        type: "number",
        headerAlign: "left",
        width: 200,
      },
      {
        dataIndex: "title",
        title: "Title",
        width: 200,
      },
      {
        dataIndex: "desc",
        title: "Desc",
        width: 300,
      },
      {
        dataIndex: "created_at",
        title: "Created At",
        width: 200,
      },
      {
        dataIndex: "is_read",
        title: "Is Read",
        headerAlign: "left",
        width: 50,
        render: (_, record) => {
          return (
            <BooleanField
              value={record.is_read === true}
              trueIcon={"True"}
              falseIcon={"False"}
            />
          );
        },
      },
      {
        dataIndex: "actions",
        title: "Actions",
        render: (_, record) => {
          return (
            <>
              <EditButton hideText recordItemId={record.notification_id} />
              <DeleteButton hideText recordItemId={record.notification_id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        width: 80,
        fixed: "right",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          {defaultButtons}
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        rowKey="notification_id"
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
